import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-building',
  templateUrl: './icon-building.component.html',
  styles: []
})
export class IconBuildingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
